const targetNodeNL = document.getElementById('efbc6b69-3ca3-4e8b-a7c5-5911e035e70a');

if (targetNodeNL) {
  const config = { attributes: true, childList: true, subtree: true };
  const callback = function(mutationsList, observer) {
    for(const mutation of mutationsList) {
      if (mutation.type === 'childList') {
      }
      else if (mutation.type === 'attributes') {

        const scriptElement = document.createElement('script');
        const styleElement = document.createElement('style');
        
        const cssSnippet = `
          #form-container-ref * {
            box-sizing: border-box !important;
          }
          ._container_3eyaa_70 {
            padding: 3rem 0;
          }
        ._inline_1l8ap_45 ._formContainer_1l8ap_30 {
            max-width: var(--x-small) !important;
        }
        form._formFieldset_g1wk8_68 {
            max-width: var(--max-width-newsletterform) !important;
            margin: 0 auto !important;
        }
        ._formHeader_g1wk8_20 {
            display: flex !important;
            flex-direction: column-reverse !important;
        }
        ._textBody_2aowh_10 p {
            font-size: 1.5rem;
        }
        ._textHeading_2aowh_35._textHeading_g1wk8_34 {
            font-family: var(--font-heading-family) !important;
            font-size: var(--h2-size) !important;
            line-height: 1.2 !important;
            margin: 1rem 0 !important;
        }
        ._textBody_2aowh_10 p {
            font-family: var(--font-body-family) !important;
        }
        ._formFieldset_g1wk8_68 > ._formFieldContainer_1oy4y_5:first-child {
            position: relative !important;
            padding-top: 2.5rem !important;
        }
        ._formFieldset_g1wk8_68 > ._formFieldContainer_1oy4y_5:first-child ._formInputFieldLabel_1oy4y_37 {
            padding-top: 2.3rem !important;
        }
        ._formFieldContainer_1oy4y_5:last-child::before {
            content: none !important;
        }
        ._formFieldset_g1wk8_68 > ._formFieldContainer_1oy4y_5:first-child::before {
            content: 'Das Wichtigste zuerst:' !important;
            position: absolute !important;
            font-family: var(--font-body-family) !important;
            font-size: 1.25rem !important;
            font-weight: var(--font-weight-bold) !important;
            top: 0 !important;
            left: 0 !important;
            width: 100% !important;
            height: 1.5rem !important;
        }
        ._label_1ujcz_10 {
            position: relative !important;
            padding-top: 2rem !important;
            margin-top: 1.5rem !important;
        }
        ._label_1ujcz_10::before {
            content: 'Und damit es netter wird (optional)' !important;
            position: absolute !important;
            font-family: var(--font-body-family) !important;
            font-size: 1.25rem !important;
            font-weight: var(--font-weight-bold) !important;
            top: 0 !important;
            left: 0 !important;
            width: 100% !important;
            height: 1.5rem !important;
        }
        ._formFieldset_g1wk8_68 input {
            background-color: var(--white-color) !important;
            width: 100% !important;
            height: 3rem !important;
            border-radius: var(--default-border-radius) !important;
            border: none !important;
            padding: 0 0.75rem !important;
            font-family: var(--font-body-family) !important;
        }
        ._formFieldset_g1wk8_68 ._selectToggle_1ujcz_25 {
            background-color: var(--white-color) !important;
            width: 100% !important;
            height: 3rem !important;
            border-radius: var(--default-border-radius) !important;
            border: none !important;
            padding: 0 0.75rem !important;
            font-family: var(--font-body-family) !important;
        }
        ._formDisclaimer_g1wk8_38 {
            text-align: left !important;
            max-width: var(--max-width-newsletterform) !important;
            margin: 0 auto !important;
        }
        ._formDisclaimer_g1wk8_38 a {
            color: var(--primary-color) !important;
        }
        ._formSubmitButton_g1wk8_82 {
            font-size: var(--button-font-size) !important;
            color: var(--button-font-color) !important;
            text-transform: uppercase !important;
            text-decoration: none !important;
            padding: var(--button-padding) !important;
            border-radius: var(--button-border-radius) !important;
            transform: translateY(0) !important;
            transition: all var(--default-transition-time) ease-in-out !important;
            cursor: pointer !important;
            appearance: none !important;
            -webkit-appearance: none !important;
            border: none !important;
            background-color: var(--primary-color) !important;
        }
        @media screen and (max-width: 767px) {
            ._textBody_2aowh_10 p {
                font-size: 1.25rem;
            }
            ._textHeading_2aowh_35._textHeading_g1wk8_34 {
                font-size: var(--h2-size-mobile) !important;
            }
            ._formFieldset_g1wk8_68 > ._formFieldContainer_1oy4y_5:first-child::before {
                font-size: 1.125rem !important;
            }
            ._label_1ujcz_10 {
                padding-top: 2.75rem !important;
            }
            ._label_1ujcz_10::before {
                font-size: 1.125rem !important;
            }
        }
        `;

        const scriptSnippet = `
              elementInShadowDOM = document.querySelector("#app-embed").shadowRoot.querySelector("._formSubmitButton_g1wk8_82");
              elementInShadowDOM.addEventListener('remove', function(event) {
              gtag('event', 'conversion', {'send_to': 'AW-755179353/1WwNCNah3OUYENm-jOgC'});
              fbq('trackCustom', 'newsletteranmeldung');
              gtag('event', '<newsletteranmeldung>');
              });
        `;
        styleElement.textContent = cssSnippet;
        scriptElement.textContent = scriptSnippet;
        

        document.head.appendChild(styleElement);
        const headElement = document.querySelector("#app-embed").shadowRoot.querySelector("._container_3eyaa_70");
        headElement.insertBefore(styleElement, headElement.firstChild);
        headElement.insertBefore(scriptElement, headElement.firstChild);
        observer.disconnect();
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNodeNL, config);
}
